var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalysisGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 75,
    viewBox: "0 0 149 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.18 74.36C33.28 74.36 0 41.08 0 0.18C0 -40.72 33.28 -74 74.18 -74C115.08 -74 148.36 -40.72 148.36 0.18C148.35 41.08 115.08 74.36 74.18 74.36ZM74.18 -70.81C35.03 -70.81 3.18997 -38.96 3.18997 0.18C3.18997 39.33 35.04 71.17 74.18 71.17C113.32 71.17 145.17 39.32 145.17 0.18C145.17 -38.96 113.32 -70.81 74.18 -70.81Z",
    fill: "#128C76"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M74.18 63.99C39 63.99 10.37 35.37 10.37 0.179993C10.37 -35 38.99 -63.63 74.18 -63.63C109.36 -63.63 137.99 -35.01 137.99 0.179993C137.98 35.37 109.36 63.99 74.18 63.99ZM74.18 -60.44C40.75 -60.44 13.56 -33.24 13.56 0.179993C13.56 33.61 40.76 60.8 74.18 60.8C107.6 60.8 134.8 33.6 134.8 0.179993C134.8 -33.24 107.6 -60.44 74.18 -60.44Z",
    fill: "#128C76"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M74.18 53.62C44.71 53.62 20.74 29.65 20.74 0.179993C20.74 -29.29 44.71 -53.26 74.18 -53.26C103.65 -53.26 127.62 -29.29 127.62 0.179993C127.61 29.65 103.64 53.62 74.18 53.62ZM74.18 -50.07C46.47 -50.07 23.93 -27.53 23.93 0.179993C23.93 27.89 46.47 50.44 74.18 50.44C101.89 50.44 124.43 27.9 124.43 0.179993C124.43 -27.53 101.89 -50.07 74.18 -50.07Z",
    fill: "#128C76"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M74.1799 43.25C50.4299 43.25 31.11 23.93 31.11 0.179985C31.11 -23.57 50.4299 -42.89 74.1799 -42.89C97.9299 -42.89 117.25 -23.57 117.25 0.179985C117.25 23.93 97.9199 43.25 74.1799 43.25ZM74.1799 -39.7C52.1899 -39.7 34.29 -21.81 34.29 0.189987C34.29 22.18 52.1799 40.08 74.1799 40.08C96.1799 40.08 114.07 22.19 114.07 0.189987C114.06 -21.81 96.1699 -39.7 74.1799 -39.7Z",
    fill: "#128C76"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisGroup);
export default __webpack_public_path__ + "static/media/analysis-group.e41c911a02463cd9b48e16ccb6e17823.svg";
export { ForwardRef as ReactComponent };